import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import {SectionNotification, SectionNotificationType} from 'wix-ui-tpa';
import {Error} from '@wix/wix-ui-icons-common/on-stage';
import s from './OutOfStock.scss';
import {useTranslation} from '@wix/yoshi-flow-editor';

export const OutOfStock = () => {
  const {t} = useTranslation();

  return (
    <div className={s.root} data-hook={CartItemDataHook.OutOfStockRoot}>
      <SectionNotification
        type={SectionNotificationType.error}
        className={s.error}
        data-hook={CartItemDataHook.OutOfStockError}>
        <SectionNotification.Icon icon={<Error />} />
        <SectionNotification.Text>{t('cart.errors.item_out_of_stock')}</SectionNotification.Text>
      </SectionNotification>
    </div>
  );
};
